export class SafetyMeeting {
    id!: string
    title!: string
    description!: string
    code!: string
    scheduledDate!: Date
    purpose!: string
}
